'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';

var Module5App3 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module5,
    app: state.moduleData.data.module5.app3
  };
}, moduleActions), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module5App3, _Component);

  function Module5App3() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module5App3);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module5App3.__proto__ || (0, _getPrototypeOf2.default)(Module5App3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 5,
      appId: 3,
      title: 'Review strategies used to reach goals',
      isCompleted: false,
      stillUse: ''
    }, _this.handleComplete = function () {
      var obj = _this.state;
      obj.isCompleted = true;
      _this.setState(obj);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * User types in something for what was
   * involved in the diet
   */


  (0, _createClass3.default)(Module5App3, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Booster Module'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'We have just provided you with a list of all the strategies used throughout the program. Did you find any of these strategies helpful?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Are you still using any of these strategies?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            { onChange: this.handleChange.bind(this, 'stillUse') },
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'seen', value: YES, checked: this.state.stillUse === YES },
              YES
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'seen', value: NO, checked: this.state.stillUse === NO },
              NO
            )
          ),
          this.state.stillUse === YES && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Well done! That is a great process; it is not easy to make changes and stick to them. Brainstorm and consider what you are doing to keep it up.'
            )
          ),
          this.state.stillUse === NO && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s okay, change is hard! Consider what you think will help you start using it again!'
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          this.state.stillUse && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          )
        )
      );
    }
  }]);
  return Module5App3;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModuleApp: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module5App3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/5/App/App3.js
// module id = 1217
// module chunks = 0